module.exports = __webpack_public_path__ + "img/03.4da1e43e.png";